module.exports = __webpack_public_path__ + "img/avatar1.050a7791.png";